/**
 * Data-source attribution.
 *
 * This is NOT optional decoration. The data.gov.hk Terms of Use permit
 * commercial re-use but REQUIRE that the source and the Government's
 * intellectual property rights are acknowledged, and the terms carry an
 * indemnity clause. Removing or hiding this notice puts the project outside
 * the licence it depends on.
 *
 * It is therefore rendered from code, always visible, and never behind a menu.
 * `assertVisible()` is called at boot and will complain loudly in the console
 * if a stylesheet change ever hides it.
 */

const NOTICE_ZH =
  '地圖及開放數據來源：DATA.GOV.HK、香港特別行政區政府地政總署、運輸署、路政署　© 香港特別行政區政府';
const NOTICE_EN =
  'Map and open data: DATA.GOV.HK; Lands Department, Transport Department and Highways Department of the HKSAR Government © The Government of the Hong Kong Special Administrative Region';

export function mountAttribution(el: HTMLElement): void {
  el.replaceChildren();
  el.className = 'attribution';

  const zh = document.createElement('span');
  zh.textContent = NOTICE_ZH;
  zh.lang = 'zh-Hant-HK';

  const en = document.createElement('span');
  en.textContent = NOTICE_EN;
  en.lang = 'en';
  en.className = 'attribution-en';

  el.append(zh, en);
  // Belt and braces: even if a stylesheet regresses, the notice stays on screen.
  el.style.display = 'block';
  el.style.visibility = 'visible';
}

/** Fails loudly rather than silently shipping without the required notice. */
export function assertAttributionVisible(el: HTMLElement): void {
  const style = getComputedStyle(el);
  const hidden =
    style.display === 'none' ||
    style.visibility === 'hidden' ||
    Number(style.opacity) < 0.2 ||
    el.getBoundingClientRect().height < 4;
  if (hidden) {
    console.error(
      '[attribution] The data source notice is not visible. This is a licence ' +
        'requirement of the data.gov.hk Terms of Use, not a styling preference.',
    );
  }
}
